import * as userPlanHelpers from '@/helpers/userPlan'

export const hasPendingTasks = state => state.pendingTasks > 0

// CLUSTERS GETTERS

export const clustersUserPlans = state =>
  state.userPlans.filter(userPlanHelpers.isCluster)

export const startedClusters = state =>
  state.clusters.filter(
    cluster => cluster.state === 'started' || cluster.state === 'updating'
  )

export const stoppedClusters = state =>
  state.clusters.filter(cluster => cluster.state === 'stopped')

export const activeClustersUserPlans = (_, getters) =>
  getters.clustersUserPlans.filter(userPlanHelpers.isActive)

export const pendingClustersUserPlans = (_, getters) =>
  getters.clustersUserPlans
    // exclude already paid or expired plans
    .filter(userPlanHelpers.isPending)

    // exclude renewals of inactive plans
    .filter(
      userPlan =>
        !userPlanHelpers.isRenewal(userPlan) ||
        getters.activeClustersUserPlans.some(
          activePlan => userPlan.renewedFrom === activePlan.id
        )
    )

export const unpaidClusterSetup = (_, getters) => userPlanId =>
  getters.pendingClustersUserPlans.find(
    userPlan =>
      !userPlanHelpers.isProcessingPayment(userPlan) &&
      userPlan.id === userPlanId
  )

export const unpaidClusterRenewal = (_, getters) => renewedFromUserPlanId =>
  getters.pendingClustersUserPlans.find(
    userPlan =>
      !userPlanHelpers.isProcessingPayment(userPlan) &&
      Boolean(userPlan.renewedFrom) &&
      userPlan.renewedFrom === renewedFromUserPlanId
  )

export const isProcessingClustersPayment = (_, getters) => userPlanId =>
  getters.pendingClustersUserPlans.some(
    userPlan =>
      userPlanHelpers.isProcessingPayment(userPlan) &&
      userPlan.renewedFrom === userPlanId
  )

// NODES GETTERS

export const nodesUserPlans = state =>
  state.userPlans.filter(userPlanHelpers.isNodes)

export const startedNodes = state =>
  state.nodes.filter(node => node.state === 'started')

export const stoppedNodes = state =>
  state.nodes.filter(node => node.state === 'stopped')

export const activeNodesUserPlans = (_, getters) =>
  getters.nodesUserPlans.filter(userPlanHelpers.isActive)

export const futureNodesRenewals = (_, getters) =>
  getters.nodesUserPlans.find(userPlanHelpers.isFutureRenewal)

export const pendingNodesUserPlans = (_, getters) =>
  getters.nodesUserPlans
    // exclude already paid or expired plans
    .filter(userPlanHelpers.isPending)

    // exclude renewals of inactive plans
    .filter(
      userPlan =>
        !userPlanHelpers.isRenewal(userPlan) ||
        getters.activeNodesUserPlans.some(
          activePlan => userPlan.renewedFrom === activePlan.id
        )
    )

export const unpaidNodeSetup = (_, getters) => userPlanId =>
  getters.pendingNodesUserPlans.find(
    userPlan =>
      !userPlanHelpers.isProcessingPayment(userPlan) &&
      userPlan.id === userPlanId
  )

export const unpaidNodeRenewal = (_, getters) => renewedFromUserPlanId =>
  getters.pendingNodesUserPlans.find(
    userPlan =>
      !userPlanHelpers.isProcessingPayment(userPlan) &&
      Boolean(userPlan.renewedFrom) &&
      userPlan.renewedFrom === renewedFromUserPlanId
  )

export const isProcessingNodesPayment = (_, getters) => userPlanId =>
  getters.pendingNodesUserPlans.some(
    userPlan =>
      userPlanHelpers.isProcessingPayment(userPlan) &&
      userPlan.renewedFrom === userPlanId
  )

export const userPlanById = state => userPlanId =>
  state.userPlans.find(({ id }) => id === userPlanId)

export const nodeByUserPlanId = state => userPlanId =>
  state.nodes.find(({ userPlanData }) => userPlanData.id === userPlanId)

export const projectsToggle = state => state.projectsToggle
